if (!customElements.get('main-blog')) {
  customElements.define(
    'main-blog',
    class MainBlog extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.fieldset = this.querySelector('fieldset');
        this.handleChange = this.handleChange.bind(this);

        this.fieldset.addEventListener('change', this.handleChange);
      }

      disconnectedCallback() {
        this.fieldset.removeEventListener('change', this.handleChange);
      }

      handleChange(event) {
        if (event.target.checked == false) {
          const tag = event.target.name;
          let newHref = window.location.href;
          newHref = newHref.replace(`+${tag}`,"").replace(`${tag}+`,"").replace(`/tagged/${tag}`,"");
          window.location.href = newHref;
        }
      }
    }
  )
}